module.exports = __webpack_public_path__ + "static/media/checkin.6c116a39.svg";